const _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children"],
  _excluded5 = ["children"],
  _excluded6 = ["children", "className"],
  _excluded7 = ["children"],
  _excluded8 = ["children"],
  _excluded9 = ["children", "toInternalLink", "onClick", "target", "toExternalLink"],
  _excluded10 = ["toInternalLink"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import styles from "./FormComponents.module.scss";
import { Typography, Button, TextButton } from 'seagull';
import { Link, useLocation } from 'react-router-dom';
import cn from 'classnames';
export const FormContainer = props => {
  return /*#__PURE__*/React.createElement("form", _extends({}, props, {
    className: styles.formContainer
  }));
};
export const FormTitle = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: styles.title
  }), children);
};
export const FormSubTitle = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: styles.subTitle
  }), children);
};
export const FormDescription = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: styles.description
  }), children);
};
export const FormFields = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded4);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: styles.formFields
  }), children);
};
export const VerticalFormFields = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded5);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: styles.verticalFormFields
  }), children);
};
export const HorizontalFormFields = props => {
  const {
      children,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded6);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cn(styles.horizontalFormFields, className)
  }), children);
};
export const Footer = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded7);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: styles.footer
  }), children);
};
export const FooterText = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded8);
  return /*#__PURE__*/React.createElement(Typography, _extends({}, rest, {
    as: "span",
    variant: "paragraph2",
    skin: "disabled",
    weight: "light"
  }), children);
};
export const FooterLink = props => {
  const {
      children,
      toInternalLink,
      onClick,
      target,
      toExternalLink
    } = props,
    rest = _objectWithoutProperties(props, _excluded9);
  const location = useLocation();
  let as, componentProps;
  if (toExternalLink || toInternalLink) {
    as = Link;
    const to = toInternalLink ? {
      pathname: toInternalLink,
      search: location.search
    } : {
      pathname: toExternalLink
    };
    componentProps = {
      to,
      target
    };
  } else {
    as = 'button';
    componentProps = {
      type: 'button'
    };
  }
  return /*#__PURE__*/React.createElement(TextButton, _extends({}, rest, componentProps, {
    as: as,
    onClick: onClick,
    size: "small",
    skin: "secondary",
    underline: "none"
  }), children);
};
export const SubmitButtonField = props => {
  const {
    disabled,
    isLoading,
    children
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.submitButtonField
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    loading: isLoading,
    type: "submit",
    "data-testid": props['data-testid']
  }, children));
};
export const ErrorMessage = props => {
  return /*#__PURE__*/React.createElement(Typography, _extends({}, props, {
    skin: "error",
    variant: "paragraph2",
    "data-testid": props['data-testid'],
    className: styles.error
  }), props.children);
};
export const LinkButton = props => {
  const {
      toInternalLink
    } = props,
    rest = _objectWithoutProperties(props, _excluded10);
  return /*#__PURE__*/React.createElement(TextButton, _extends({
    as: Link,
    to: {
      pathname: toInternalLink,
      search: location.search
    },
    skin: "secondary",
    size: "small",
    underline: "none"
  }, rest));
};